module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<div class=\"close shadowed\"><i class=\"icon-close\"></i></div> <div class=\"uploader-form-wrapper clearfix\"> <% if(headline1.length>0) { %><h1><%- headline1 %></h1><% } %> <% if(headline2.length>0) { %><h2><%- headline2 %></h2><% } %> <form action=\"\" method=\"post\" class=\"uploader-form\"> <div class=\"form-wrapper\"> <% var slots = 2; %> <% var tabindex = 1; %> <% _.each(fields, function (field, index) { %> <% if(field.column === '') field.column = 'full'; %> <% if(field.column.indexOf('full') !== -1 && index > 0 && slots < 2) { %></div><% } %> <% if(field.column.indexOf('full') !== -1) { slots = 2; } %> <% if(slots === 2) { %><div class=\"row\"><% } %> <% if(field.type === \"radio\") { %> <div class=\"<%- field.column %>\"> <div class=\"form-group\"> <label class=\"radio-question\"> <%- field.label %> </label> <div class=\"radio\"> <% for(var i = 0; i < field.options_list.length; i++) { %> <% var option = field.options_list[i]; %> <label class=\"radio-inline\"> <input type=\"radio\" value=\"<%- option %>\" name=\"<%- field.id %>\" tabindex=\"<%- tabindex++ %>\"> <%- option %> </label> <% } %> </div> </div> </div> <% } else if(field.type === \"checkbox\") { %> <div class=\"<%- field.column %>\"> <div class=\"form-group\"> <div class=\"checkbox\"> <label class=\"checkbox-inline\"> <input type=\"checkbox\" value=\"true\" name=\"<%- field.id %>\" tabindex=\"<%- tabindex++ %>\"> <%- field.label %> </label> </div> </div> </div> <% } else if(field.type === \"file\") { %> <div class=\"<%- field.column %>\"> <div class=\"form-group\"> <label for=\"<%- field.id %>\"><%- field.label %></label> <div class=\"input-group file-combo <%- field.class %>\"> <span class=\"input-group-btn\"> <span class=\"btn btn-sm btn-file\"> <span class=\"icon-upload\"> <svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"-293 204 205 205\"><path d=\"M-93.1 329.8h-19c-2.8 0-4 1.2-4 4v39.4h-148v-39.4c0-2.8-1.2-4-4-4h-19c-2.8 0-5.1 1.2-5.1 4v62.7c0 2.8 2.3 4.7 5.1 4.7H-93.1c2.8 0 5.1-1.9 5.1-4.7v-19-43.7c0-2.8-2.3-4-5.1-4z\"/><path d=\"M-205.4 338.2c0 2.8 3 4.4 5.8 4.4h19c2.8 0 5.8-1.6 5.8-4.4v-54.3h43l-58.3-72.9-58.3 72.9h43v54.3z\"/></svg> </span> <%- (field.hasOwnProperty('secondary_label')) ? field.secondary_label : 'Select' %> <input type=\"<%- field.type %>\" name=\"<%- field.id %>\" class=\"uploader-file-input\" tabindex=\"<%- tabindex++ %>\"></span></span><span class=\"file-combo-text\"> <span class=\"file-upload-added\"> <svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"-293 204 205 205\"> <path d=\"M-101.7,255c9.2,15.7,13.7,32.8,13.7,51.4c0,18.6-4.6,35.7-13.7,51.4c-9.2,15.7-21.6,28.1-37.3,37.3\n        c-15.7,9.2-32.8,13.7-51.4,13.7s-35.7-4.6-51.4-13.7c-15.7-9.2-28.1-21.6-37.3-37.3c-9.2-15.7-13.7-32.8-13.7-51.4\n        c0-18.6,4.6-35.7,13.7-51.4c9.2-15.7,21.6-28.1,37.3-37.3c15.7-9.2,32.8-13.7,51.4-13.7s35.7,4.6,51.4,13.7\n        C-123.3,226.9-110.9,239.3-101.7,255z M-127.6,342.8c6.5-11.1,9.7-23.3,9.7-36.4c0-13.2-3.2-25.3-9.7-36.4\n        c-6.5-11.1-15.3-19.9-26.4-26.4c-11.1-6.5-23.3-9.7-36.4-9.7s-25.3,3.2-36.4,9.7c-11.1,6.5-19.9,15.3-26.4,26.4\n        c-6.5,11.1-9.7,23.3-9.7,36.4c0,13.2,3.2,25.3,9.7,36.4c6.5,11.1,15.3,19.9,26.4,26.4c11.1,6.5,23.3,9.7,36.4,9.7\n        s25.3-3.2,36.4-9.7C-142.9,362.7-134.1,353.9-127.6,342.8z M-136.7,295.3l-56.3,56.3c-1.7,1.7-3.7,2.5-6,2.5\n        c-2.3,0-4.3-0.8-6-2.5l-39.2-39.2c-1.7-1.7-2.5-3.7-2.5-6c0-2.3,0.8-4.3,2.5-6l13.6-13.6c1.7-1.7,3.7-2.5,6-2.5\n        c2.3,0,4.3,0.8,6,2.5l19.6,19.6l36.7-36.7c1.7-1.7,3.7-2.5,6-2.5c2.3,0,4.3,0.8,6,2.5l13.6,13.6c1.7,1.7,2.5,3.7,2.5,6\n        S-135,293.7-136.7,295.3z\"/> </svg> <span>File added</span> </span> <span class=\"file-upload-error\"> <svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"-293 204 205 205\"> <path d=\"M-96.8,266.6c5.4,12.6,8.1,25.9,8.1,39.8c0,13.9-2.7,27.2-8.1,39.9c-5.4,12.7-12.7,23.6-21.7,32.7\n        c-9.1,9.1-20,16.4-32.6,21.8c-12.6,5.4-25.9,8.1-39.7,8.1c-13.8,0-27.1-2.7-39.7-8.1s-23.5-12.7-32.6-21.8\n        c-9.1-9.1-16.3-20-21.8-32.7c-5.4-12.7-8.1-26-8.1-39.9c0-13.9,2.7-27.2,8.1-39.8c5.4-12.6,12.7-23.5,21.8-32.7\n        c9.1-9.1,20-16.4,32.6-21.8c12.6-5.4,25.9-8.1,39.7-8.1c13.8,0,27.1,2.7,39.7,8.1c12.6,5.4,23.5,12.7,32.6,21.8\n        C-109.4,243.1-102.2,254-96.8,266.6z M-251.4,346.2l100.4-100.3c-12-8.1-25.3-12.1-39.9-12.1c-13.1,0-25.2,3.2-36.3,9.7\n        c-11.1,6.5-19.9,15.3-26.3,26.5c-6.5,11.2-9.7,23.3-9.7,36.4C-263.2,320.8-259.3,334.1-251.4,346.2z M-118.5,306.4\n        c0-14.3-3.9-27.4-11.6-39.2l-100.3,100.2c12.1,7.9,25.3,11.8,39.5,11.8c9.9,0,19.2-1.9,28.1-5.8c8.9-3.9,16.6-9,23.1-15.5\n        c6.5-6.5,11.6-14.2,15.4-23.2C-120.4,325.7-118.5,316.3-118.5,306.4z\"/> </svg> <span>File error</span> </span></span> </div> <p class=\"additional_info\"><%- field.additional_info %></p> </div> </div> <% } else if (field.type === 'textarea') { %> <div class=\"<%- field.column %>\"> <div class=\"form-group <% if(field.display_counter === 'true') { %>has-counter<% } %>\"> <label for=\"<%- field.id %>\"><%- field.label %></label> <div class=\"textarea <% if(field.display_counter === 'true') { %>input-group<% } %>\"> <textarea type=\"<%- field.type %>\" class=\"<%- field.class %> form-control\" placeholder=\"<%- field.placeholder %>\" name=\"<%- field.id %>\" maxlength=\"<%- field.max_length %>\" data-maxlength=\"<%- field.max_length %>\" tabindex=\"<%- tabindex++ %>\"></textarea> <% if(field.display_counter === 'true') { %> <span class=\"input-group-counter input-group-addon\"><%- field.max_length %></span> <% } %> </div> <p class=\"additional_info\"><%- field.additional_info %></p> </div> </div> <% } else if (field.type === 'submit') { %> <div class=\"<%- field.column %>\"> <div class=\"form-group\"> <button type=\"submit\" name=\"<%- field.id %>\" class=\"<%- field.class %> btn btn-large submit\" tabindex=\"<%- tabindex++ %>\"><%- field.label %></button> <div class=\"upload-gif\" style=\"display:none\"> <img src=\"https://ts-cms-production.votenow.tv/campaign/10/01/1001654/14528121075698274b5535e0.10032325.gif\"> <label>Uploading..</label> </div> </div> </div> <% } else if (field.type === 'reset') { %> <div class=\"<%- field.column %>\"> <div class=\"form-group\"> <button type=\"reset\" name=\"<%- field.id %>\" class=\"<%- field.class %> btn btn-large submit\" tabindex=\"<%- tabindex++ %>\"><%- field.label %></button> </div> </div> <% } else if (field.type === 'select') { %> <div class=\"<%- field.column %>\"> <div class=\"form-group\"> <label for=\"<%- field.id %>\"><%- field.label %></label> <select class=\"<%- field.class %> form-control\" name=\"<%- field.id %>\" tabindex=\"<%- tabindex++ %>\"> <option value=\"\">Please Select</option> <% _.each(field.options_list, function(item, index) { %> <option value=\"<%- _.escape(item) %>\"><%- item %></option> <% }) %> </select> </div> <p class=\"additional_info\"><%- field.additional_info %></p> </div> <% } else if (field.type === 'section') { %> <div class=\"<%- field.column %> separator\"> <h3><%- field.label %></h3> </div> <% } else { %> <div class=\"<%- field.column %>\"> <div class=\"form-group <% if(field.display_counter === 'true') { %>has-counter<% } %>\"> <label for=\"<%- field.id %>\"><%- field.label %></label> <div class=\"<% if(field.display_counter === 'true') { %>input-group<% } %>\"> <input type=\"<%- field.type %>\" placeholder=\"<%- field.placeholder %>\" class=\"<%- field.class %> form-control\" name=\"<%- field.id %>\" maxlength=\"<%- field.max_length %>\" data-maxlength=\"<%- field.max_length %>\" tabindex=\"<%- tabindex++ %>\"> <% if(field.display_counter === 'true') { %> <span class=\"input-group-counter input-group-addon\"><%- field.max_length %></span> <% } %> </div> <p class=\"additional_info\"><%- field.additional_info %></p> </div> </div> <% } %> <% if(field.column.indexOf('full') !== -1) { slots = 0; } %> <% if(field.column.indexOf('half') !== -1) { slots--; } %> <% if(slots === 0) { slots = 2; %></div><% } %> <% }) %> </form></div> "
  , __filename = undefined;
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div class=\"close shadowed\"><i class=\"icon-close\"></i></div> <div class=\"uploader-form-wrapper clearfix\"> ")
    ;  if(headline1.length>0) { 
    ; __append("<h1>")
    ; __append( headline1 )
    ; __append("</h1>")
    ;  } 
    ; __append(" ")
    ;  if(headline2.length>0) { 
    ; __append("<h2>")
    ; __append( headline2 )
    ; __append("</h2>")
    ;  } 
    ; __append(" <form action=\"\" method=\"post\" class=\"uploader-form\"> <div class=\"form-wrapper\"> ")
    ;  var slots = 2; 
    ; __append(" ")
    ;  var tabindex = 1; 
    ; __append(" ")
    ;  _.each(fields, function (field, index) { 
    ; __append(" ")
    ;  if(field.column === '') field.column = 'full'; 
    ; __append(" ")
    ;  if(field.column.indexOf('full') !== -1 && index > 0 && slots < 2) { 
    ; __append("</div>")
    ;  } 
    ; __append(" ")
    ;  if(field.column.indexOf('full') !== -1) { slots = 2; } 
    ; __append(" ")
    ;  if(slots === 2) { 
    ; __append("<div class=\"row\">")
    ;  } 
    ; __append(" ")
    ;  if(field.type === "radio") { 
    ; __append(" <div class=\"")
    ; __append( field.column )
    ; __append("\"> <div class=\"form-group\"> <label class=\"radio-question\"> ")
    ; __append( field.label )
    ; __append(" </label> <div class=\"radio\"> ")
    ;  for(var i = 0; i < field.options_list.length; i++) { 
    ; __append(" ")
    ;  var option = field.options_list[i]; 
    ; __append(" <label class=\"radio-inline\"> <input type=\"radio\" value=\"")
    ; __append( option )
    ; __append("\" name=\"")
    ; __append( field.id )
    ; __append("\" tabindex=\"")
    ; __append( tabindex++ )
    ; __append("\"> ")
    ; __append( option )
    ; __append(" </label> ")
    ;  } 
    ; __append(" </div> </div> </div> ")
    ;  } else if(field.type === "checkbox") { 
    ; __append(" <div class=\"")
    ; __append( field.column )
    ; __append("\"> <div class=\"form-group\"> <div class=\"checkbox\"> <label class=\"checkbox-inline\"> <input type=\"checkbox\" value=\"true\" name=\"")
    ; __append( field.id )
    ; __append("\" tabindex=\"")
    ; __append( tabindex++ )
    ; __append("\"> ")
    ; __append( field.label )
    ; __append(" </label> </div> </div> </div> ")
    ;  } else if(field.type === "file") { 
    ; __append(" <div class=\"")
    ; __append( field.column )
    ; __append("\"> <div class=\"form-group\"> <label for=\"")
    ; __append( field.id )
    ; __append("\">")
    ; __append( field.label )
    ; __append("</label> <div class=\"input-group file-combo ")
    ; __append( field.class )
    ; __append("\"> <span class=\"input-group-btn\"> <span class=\"btn btn-sm btn-file\"> <span class=\"icon-upload\"> <svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"-293 204 205 205\"><path d=\"M-93.1 329.8h-19c-2.8 0-4 1.2-4 4v39.4h-148v-39.4c0-2.8-1.2-4-4-4h-19c-2.8 0-5.1 1.2-5.1 4v62.7c0 2.8 2.3 4.7 5.1 4.7H-93.1c2.8 0 5.1-1.9 5.1-4.7v-19-43.7c0-2.8-2.3-4-5.1-4z\"/><path d=\"M-205.4 338.2c0 2.8 3 4.4 5.8 4.4h19c2.8 0 5.8-1.6 5.8-4.4v-54.3h43l-58.3-72.9-58.3 72.9h43v54.3z\"/></svg> </span> ")
    ; __append( (field.hasOwnProperty('secondary_label')) ? field.secondary_label : 'Select' )
    ; __append(" <input type=\"")
    ; __append( field.type )
    ; __append("\" name=\"")
    ; __append( field.id )
    ; __append("\" class=\"uploader-file-input\" tabindex=\"")
    ; __append( tabindex++ )
    ; __append("\"></span></span><span class=\"file-combo-text\"> <span class=\"file-upload-added\"> <svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"-293 204 205 205\"> <path d=\"M-101.7,255c9.2,15.7,13.7,32.8,13.7,51.4c0,18.6-4.6,35.7-13.7,51.4c-9.2,15.7-21.6,28.1-37.3,37.3\n        c-15.7,9.2-32.8,13.7-51.4,13.7s-35.7-4.6-51.4-13.7c-15.7-9.2-28.1-21.6-37.3-37.3c-9.2-15.7-13.7-32.8-13.7-51.4\n        c0-18.6,4.6-35.7,13.7-51.4c9.2-15.7,21.6-28.1,37.3-37.3c15.7-9.2,32.8-13.7,51.4-13.7s35.7,4.6,51.4,13.7\n        C-123.3,226.9-110.9,239.3-101.7,255z M-127.6,342.8c6.5-11.1,9.7-23.3,9.7-36.4c0-13.2-3.2-25.3-9.7-36.4\n        c-6.5-11.1-15.3-19.9-26.4-26.4c-11.1-6.5-23.3-9.7-36.4-9.7s-25.3,3.2-36.4,9.7c-11.1,6.5-19.9,15.3-26.4,26.4\n        c-6.5,11.1-9.7,23.3-9.7,36.4c0,13.2,3.2,25.3,9.7,36.4c6.5,11.1,15.3,19.9,26.4,26.4c11.1,6.5,23.3,9.7,36.4,9.7\n        s25.3-3.2,36.4-9.7C-142.9,362.7-134.1,353.9-127.6,342.8z M-136.7,295.3l-56.3,56.3c-1.7,1.7-3.7,2.5-6,2.5\n        c-2.3,0-4.3-0.8-6-2.5l-39.2-39.2c-1.7-1.7-2.5-3.7-2.5-6c0-2.3,0.8-4.3,2.5-6l13.6-13.6c1.7-1.7,3.7-2.5,6-2.5\n        c2.3,0,4.3,0.8,6,2.5l19.6,19.6l36.7-36.7c1.7-1.7,3.7-2.5,6-2.5c2.3,0,4.3,0.8,6,2.5l13.6,13.6c1.7,1.7,2.5,3.7,2.5,6\n        S-135,293.7-136.7,295.3z\"/> </svg> <span>File added</span> </span> <span class=\"file-upload-error\"> <svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"-293 204 205 205\"> <path d=\"M-96.8,266.6c5.4,12.6,8.1,25.9,8.1,39.8c0,13.9-2.7,27.2-8.1,39.9c-5.4,12.7-12.7,23.6-21.7,32.7\n        c-9.1,9.1-20,16.4-32.6,21.8c-12.6,5.4-25.9,8.1-39.7,8.1c-13.8,0-27.1-2.7-39.7-8.1s-23.5-12.7-32.6-21.8\n        c-9.1-9.1-16.3-20-21.8-32.7c-5.4-12.7-8.1-26-8.1-39.9c0-13.9,2.7-27.2,8.1-39.8c5.4-12.6,12.7-23.5,21.8-32.7\n        c9.1-9.1,20-16.4,32.6-21.8c12.6-5.4,25.9-8.1,39.7-8.1c13.8,0,27.1,2.7,39.7,8.1c12.6,5.4,23.5,12.7,32.6,21.8\n        C-109.4,243.1-102.2,254-96.8,266.6z M-251.4,346.2l100.4-100.3c-12-8.1-25.3-12.1-39.9-12.1c-13.1,0-25.2,3.2-36.3,9.7\n        c-11.1,6.5-19.9,15.3-26.3,26.5c-6.5,11.2-9.7,23.3-9.7,36.4C-263.2,320.8-259.3,334.1-251.4,346.2z M-118.5,306.4\n        c0-14.3-3.9-27.4-11.6-39.2l-100.3,100.2c12.1,7.9,25.3,11.8,39.5,11.8c9.9,0,19.2-1.9,28.1-5.8c8.9-3.9,16.6-9,23.1-15.5\n        c6.5-6.5,11.6-14.2,15.4-23.2C-120.4,325.7-118.5,316.3-118.5,306.4z\"/> </svg> <span>File error</span> </span></span> </div> <p class=\"additional_info\">")
    ; __line = 17
    ; __append( field.additional_info )
    ; __append("</p> </div> </div> ")
    ;  } else if (field.type === 'textarea') { 
    ; __append(" <div class=\"")
    ; __append( field.column )
    ; __append("\"> <div class=\"form-group ")
    ;  if(field.display_counter === 'true') { 
    ; __append("has-counter")
    ;  } 
    ; __append("\"> <label for=\"")
    ; __append( field.id )
    ; __append("\">")
    ; __append( field.label )
    ; __append("</label> <div class=\"textarea ")
    ;  if(field.display_counter === 'true') { 
    ; __append("input-group")
    ;  } 
    ; __append("\"> <textarea type=\"")
    ; __append( field.type )
    ; __append("\" class=\"")
    ; __append( field.class )
    ; __append(" form-control\" placeholder=\"")
    ; __append( field.placeholder )
    ; __append("\" name=\"")
    ; __append( field.id )
    ; __append("\" maxlength=\"")
    ; __append( field.max_length )
    ; __append("\" data-maxlength=\"")
    ; __append( field.max_length )
    ; __append("\" tabindex=\"")
    ; __append( tabindex++ )
    ; __append("\"></textarea> ")
    ;  if(field.display_counter === 'true') { 
    ; __append(" <span class=\"input-group-counter input-group-addon\">")
    ; __append( field.max_length )
    ; __append("</span> ")
    ;  } 
    ; __append(" </div> <p class=\"additional_info\">")
    ; __append( field.additional_info )
    ; __append("</p> </div> </div> ")
    ;  } else if (field.type === 'submit') { 
    ; __append(" <div class=\"")
    ; __append( field.column )
    ; __append("\"> <div class=\"form-group\"> <button type=\"submit\" name=\"")
    ; __append( field.id )
    ; __append("\" class=\"")
    ; __append( field.class )
    ; __append(" btn btn-large submit\" tabindex=\"")
    ; __append( tabindex++ )
    ; __append("\">")
    ; __append( field.label )
    ; __append("</button> <div class=\"upload-gif\" style=\"display:none\"> <img src=\"https://ts-cms-production.votenow.tv/campaign/10/01/1001654/14528121075698274b5535e0.10032325.gif\"> <label>Uploading..</label> </div> </div> </div> ")
    ;  } else if (field.type === 'reset') { 
    ; __append(" <div class=\"")
    ; __append( field.column )
    ; __append("\"> <div class=\"form-group\"> <button type=\"reset\" name=\"")
    ; __append( field.id )
    ; __append("\" class=\"")
    ; __append( field.class )
    ; __append(" btn btn-large submit\" tabindex=\"")
    ; __append( tabindex++ )
    ; __append("\">")
    ; __append( field.label )
    ; __append("</button> </div> </div> ")
    ;  } else if (field.type === 'select') { 
    ; __append(" <div class=\"")
    ; __append( field.column )
    ; __append("\"> <div class=\"form-group\"> <label for=\"")
    ; __append( field.id )
    ; __append("\">")
    ; __append( field.label )
    ; __append("</label> <select class=\"")
    ; __append( field.class )
    ; __append(" form-control\" name=\"")
    ; __append( field.id )
    ; __append("\" tabindex=\"")
    ; __append( tabindex++ )
    ; __append("\"> <option value=\"\">Please Select</option> ")
    ;  _.each(field.options_list, function(item, index) { 
    ; __append(" <option value=\"")
    ; __append( _.escape(item) )
    ; __append("\">")
    ; __append( item )
    ; __append("</option> ")
    ;  }) 
    ; __append(" </select> </div> <p class=\"additional_info\">")
    ; __append( field.additional_info )
    ; __append("</p> </div> ")
    ;  } else if (field.type === 'section') { 
    ; __append(" <div class=\"")
    ; __append( field.column )
    ; __append(" separator\"> <h3>")
    ; __append( field.label )
    ; __append("</h3> </div> ")
    ;  } else { 
    ; __append(" <div class=\"")
    ; __append( field.column )
    ; __append("\"> <div class=\"form-group ")
    ;  if(field.display_counter === 'true') { 
    ; __append("has-counter")
    ;  } 
    ; __append("\"> <label for=\"")
    ; __append( field.id )
    ; __append("\">")
    ; __append( field.label )
    ; __append("</label> <div class=\"")
    ;  if(field.display_counter === 'true') { 
    ; __append("input-group")
    ;  } 
    ; __append("\"> <input type=\"")
    ; __append( field.type )
    ; __append("\" placeholder=\"")
    ; __append( field.placeholder )
    ; __append("\" class=\"")
    ; __append( field.class )
    ; __append(" form-control\" name=\"")
    ; __append( field.id )
    ; __append("\" maxlength=\"")
    ; __append( field.max_length )
    ; __append("\" data-maxlength=\"")
    ; __append( field.max_length )
    ; __append("\" tabindex=\"")
    ; __append( tabindex++ )
    ; __append("\"> ")
    ;  if(field.display_counter === 'true') { 
    ; __append(" <span class=\"input-group-counter input-group-addon\">")
    ; __append( field.max_length )
    ; __append("</span> ")
    ;  } 
    ; __append(" </div> <p class=\"additional_info\">")
    ; __append( field.additional_info )
    ; __append("</p> </div> </div> ")
    ;  } 
    ; __append(" ")
    ;  if(field.column.indexOf('full') !== -1) { slots = 0; } 
    ; __append(" ")
    ;  if(field.column.indexOf('half') !== -1) { slots--; } 
    ; __append(" ")
    ;  if(slots === 0) { slots = 2; 
    ; __append("</div>")
    ;  } 
    ; __append(" ")
    ;  }) 
    ; __append(" </form></div> ")
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

}